/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
/**
 * Represents a single product item for bulk import operations
 * Supports upsert operations with flexible identifier matching:
 * - Can update by sourceId (preferred for external systems)
 * - Can update by name (default for name-based matching)
 * - Can update by id (when name is omitted)
 * - Must provide at least one identifier: name, id, or sourceId
 */
export type CatalogProductImportItem = {
    /**
     * Product description
     */
    description?: string | null;
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    currency?: CatalogProductImportItem.currency | null;
    /**
     * Optional reference to the analysis configuration
     */
    analysisConfigId?: number | null;
    /**
     * Optional custom fields for the product
     */
    customFields?: Dictionary_unknown_;
    /**
     * Optional external identifier for idempotent upserts
     */
    sourceId?: string;
    /**
     * External URL referencing the product
     */
    sourceUrl?: string | null;
    /**
     * Optional canonical price in the provided currency
     */
    price?: string | null;
    /**
     * Optional product name for creation or name-based matching
     */
    name?: string;
    /**
     * Optional product ID for update operations
     */
    id?: number;
};
export namespace CatalogProductImportItem {
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    export enum currency {
        CLP = 'CLP',
        UF = 'UF',
    }
}

